<!--Main Grid-->
<div class="SummaryGrid">
	<label style="margin: 0px">School:</label>
	<!-- <select [disabled]="isProcessing == true" class="form-control" [(ngModel)]="SchoolID">
        <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
    </select> -->

	<caass-schoolselector [ShowAll]="false" [Disabled]="isProcessing == true"> </caass-schoolselector>

	<label>Account Type:</label>
	<select [disabled]="isProcessing == true" class="form-control" name="AccountTypeSelector" [(ngModel)]="AccountTypeID">
		<option *ngFor="let r of lstType" [ngValue]="r.ID">{{ r.Desc }}</option>
	</select>

	<label style="margin: 0px">Owed By:</label>
	<div class="RadioMenu">
		<input
			[disabled]="isProcessing == true"
			style="margin: 0px"
			id="StudentOwed"
			value="1"
			name="IsOwedByStudent"
			[(ngModel)]="IsOwedByStudent"
			type="radio"
		/>
		<label style="margin: 0px" for="StudentOwed">Owed By Students (Credit)</label>

		<input
			[disabled]="isProcessing == true"
			style="margin: 0px"
			id="SchoolOwed"
			value="0"
			name="IsOwedByStudent"
			[(ngModel)]="IsOwedByStudent"
			type="radio"
		/>
		<label style="margin: 0px" for="SchoolOwed">Owed By School (Debit)</label>
	</div>

	<label>Last Transaction Date:</label>
	<p-calendar [disabled]="isProcessing == true" [(ngModel)]="LastFineMeal" showIcon="true" showButtonBar="true"></p-calendar>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onPrint()">Print</button>
	<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="form-group TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<div class="form-group TopMargin">
	<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">
		Processing (NOTE: It may take a while to get all of the data from the database).Please wait...
	</div>
</div>
